import React from 'react';
import { translate } from 'react-i18next';
import {Icon} from '../../Common/Icon';
import cx from '../../../styles';
import { generateDomainCommunityUrl, getUrlImage, makeRoute } from '../../../helpers';
import CONFIG, { defaultCountry, isBeYeuTemplate } from '../../../config'
// import './style.css';

const SocialLinksHtml = ({socialLinks, config}) => {
    return (
        <div className={cx("social-links-wrap")}>
            <div className={cx("footer-logo")}>
                <img src={config.region.s3Prefix + config.region.footerLogoImage} alt={`${config.region.keyword}-Logo`} loading="lazy" width="280" height="54" />
            </div>
            <div className={cx("footer-social-icons")}>
            {   
                socialLinks && socialLinks['fb'] &&
                <a href={`${socialLinks['fb']}`} target="_blank" rel="noopener noreferrer" aria-label="Go to theAsianparent facebook page">
                    <Icon name="facebook-icon-regular" color="#000" />
                </a>
            }
            {
                socialLinks && socialLinks['insta'] &&
                <a href={`${socialLinks['insta']}`} target="_blank" rel="noopener noreferrer" aria-label="Go to theAsianparent instagram page">
                    <Icon name="instagram-icon-regular" color="#000" />
                </a>
            }
            {
                socialLinks && socialLinks['twitter'] &&
                 <a href={`${socialLinks['twitter']}`} target="_blank" rel="noopener noreferrer" aria-label="Go to theAsianparent twitter page">
                    <Icon name="twitter-icon-regular" color="#000" />
                </a>   
            }
            {
                socialLinks && socialLinks['youtube'] &&
                <a href={`${socialLinks['youtube']}`} target="_blank" rel="noopener noreferrer" aria-label="Go to theAsianparent youtube page">
                    <Icon name="youtube-icon-regular" color="#000" />
                </a>
            }
            {
                socialLinks && socialLinks['tiktok'] &&
                <a href={`${socialLinks['tiktok']}`} target="_blank" rel="noopener noreferrer" aria-label="Go to theAsianparent instagram page">
                    <Icon name="tiktok-platform-regular" color="#000" />
                </a>
            }
                
            </div>
        </div>
    )
}

const Footer = ({config, country, t, appReducer}) => {
    const countryList = ["sg", "ph", "id", "my", "vn", "th", "in", "jp", "tw", "hk"];
    if(countryList.indexOf(country) == -1) country = defaultCountry;
    const socialLinks = config.socialLinks[country];
    const year = new Date().getFullYear();
    
    return (
        <footer>
                <div className={cx("footer-container")}>
                    <div className={("footer-row2")}>
                        <div className={cx('only-mobile')}>
                            <SocialLinksHtml socialLinks={socialLinks} config={config} />
                        </div>
                    </div>
                  <div>
                    <div className={cx("footer-row1")}>
                        <nav>
                            <div className={cx("nav-items")}>
                                <a href={makeRoute('/feed', appReducer)}>
                                    <div className={cx("nav-icons")}>
                                        <Icon name="feed-icon-regular" />
                                    </div>
                                    <div className={cx("nav-title")}>
                                        {t('menu_feed')}
                                    </div>
                                    <p>
                                        {t('footer_feed_desc')}
                                    </p>
                                </a>
                            </div>
                            <div className={cx("nav-items")}>
                                <a href={makeRoute("/feed/poll", appReducer)}>
                                    <div className={cx("nav-icons")}>
                                        <Icon name="poll-icon-regular" />
                                    </div>
                                    <div className={cx("nav-title")}>
                                        {t('community_tab_poll')}
                                    </div>
                                    <p>
                                        {t('footer_poll_desc')}
                                    </p>
                                </a>
                            </div>
                            <div className={cx("nav-items")}>
                                <a href={makeRoute("/booth", appReducer)}>
                                    <div className={cx("nav-icons")}>
                                        <Icon name="camera-regular-gray-md" />
                                    </div>
                                    <div className={cx("nav-title")}>
                                        {t('community_tab_booth')}
                                    </div>
                                    <p>
                                        {t('footer_photos_desc')}
                                    </p>
                                </a>
                            </div>
                            <div className={cx("nav-items")}>
                                <a href={makeRoute("/topics", appReducer)}>
                                    <div className={cx("nav-icons")}>
                                        <Icon name="target-icon-regular" />
                                    </div>
                                    <div className={cx("nav-title")}>
                                        {t('community_tab_topic')}
                                    </div>
                                    <p>
                                        {t('footer_topics_desc')}
                                    </p>
                                </a>
                            </div>
                            <div className={cx("nav-items")}>
                                <a href={makeRoute("/tracker", appReducer)}>
                                    <div className={cx("nav-icons")}>
                                        <Icon name="trophy-icon-regular" />
                                    </div>
                                    <div className={cx("nav-title")}>
                                        {t('home_tracker_title')}
                                    </div>
                                    <p>
                                        {t('footer_tracker_desc')}
                                    </p>
                                </a>
                            </div>  
                        </nav>
                    </div>

                    {
                      isBeYeuTemplate &&
                      <div className={cx('footer-info')}>
                        <div className={cx('footer-info__company')}>
                          <p>
                            CÔNG TY CỔ PHẦN THE PARENT<br />Tầng 4, Công Viên Phần Mềm Quang Trung,
                            Số 01 Tô Ký, Phường Tân Chánh Hiệp, Quận 12, Thành phố Hồ Chí Minh, Việt Nam
                            <br />Điện thoại: (+84)028 7109 7772
                            <br />Hotline: 086 641 0566
                            <br />Email: 
                            <a href="mailto:info@beyeu.com">info@beyeu.com</a>
                          </p>
                        </div>

                        <p className={cx('footer-info__company')}>
                          GPTLMXH số 357/GP-BTTTT do Bộ Thông tin và Truyền Thông cấp thay đổi lần 1 ngày 15/07/2022. Chịu trách nhiệm nội dung: Đặng Thị Nghệ Hà.
                        </p>

                        <div className={cx('product-info')}>
                          <div className={cx('product-info__links')}>
                            <a
                              className={cx('product-info__contact')}
                              href="https://baogia.webtretho.com/b%C3%A9-y%C3%AAu">
                              Liên hệ quảng cáo</a>
                          </div>
                        </div>
                      </div>
                    }

                    <div className={cx("footer-row2", "footer-row2-mobile")}>
                        <div className={cx('not-mobile', 'pull-left')}>
                            <SocialLinksHtml socialLinks={socialLinks} config={config} />
                        </div>

                        {
                            config['region'].region == 'asia' &&
                            <div className={cx('pull-right', 'app-download-btn')}>
                                <p>
                                    {t('footer_free_app_download')}
                                </p>
                                <a href={isBeYeuTemplate ? CONFIG.region.appDownload : makeRoute("https://community.theasianparent.com/app/download?mt=8", appReducer)} 
                                  aria-label={`Download ${isBeYeuTemplate ? 'BeYeu' : 'theAsianparent' } app from google play store`}>
                                    <img src={getUrlImage({imgPath: 'prod-beyeu-assets/community/icon-android.svg', defaultImgPath: 'html-edm/2018/sep/tap-welcome/icon-android.svg'})} alt="google play store" loading="lazy" width="177" height="52" />
                                </a>
                                <a href={isBeYeuTemplate ? CONFIG.region.appDownload : makeRoute("https://community.theasianparent.com/app/download", appReducer)} 
                                  aria-label={`Download ${isBeYeuTemplate ? 'BeYeu' : 'theAsianparent' } app from app store`}>
                                    <img src={getUrlImage({imgPath: 'prod-beyeu-assets/community/icon-ios.svg', defaultImgPath: 'html-edm/2018/sep/tap-welcome/icon-ios.svg'})} alt="app store" loading="lazy" width="177" height="52" />
                                </a>
                            </div>
                        }

                        <div className={cx("clear-fix")}></div>
                    </div>
                    {
                      isBeYeuTemplate &&
                      <div className={cx('footer-info', 'footer-info-mobile')}>
                        <div className={cx('footer-info__company')}>
                          <p>
                            CÔNG TY CỔ PHẦN THE PARENT<br />Tầng 4, Công Viên Phần Mềm Quang Trung,
                            Số 01 Tô Ký, Phường Tân Chánh Hiệp, Quận 12, Thành phố Hồ Chí Minh, Việt Nam
                            <br />Điện thoại: (+84)028 7109 7772
                            <br />Hotline: 086 641 0566
                            <br />Email: 
                            <a href="mailto:info@beyeu.com">info@beyeu.com</a>
                          </p>
                        </div>

                        <p className={cx('footer-info__company')}>
                          GPTLMXH số 357/GP-BTTTT do Bộ Thông tin và Truyền Thông cấp thay đổi lần 1 ngày 15/07/2022. Chịu trách nhiệm nội dung: Đặng Thị Nghệ Hà.
                        </p>

                        <div className={cx('product-info')}>
                          <div className={cx('product-info__links')}>
                            <a
                              className={cx('product-info__contact')}
                              href="https://baogia.webtretho.com/b%C3%A9-y%C3%AAu">
                              Liên hệ quảng cáo</a>
                          </div>
                        </div>
                      </div>
                    }
                    <div className={cx("clear-fix")}></div>
                  </div>
            </div>    
            <div className={cx("footer-row3")}>
                <div className={cx("bottom-nav-container")}>
                    <div className={("copyright")}>
                            &copy; Copyright {config.region.siteName} {year}. All rights reserved
                    </div>
                    <div className={("right-nav")}>
                            {
                                isBeYeuTemplate ? (
                                    <ul>
                                        {/* <li><a href={}>{t('menu_about_us')}</a></li> */}
                                        <li><a href={generateDomainCommunityUrl({country: defaultCountry, slug: 'terms-and-conditions'})}>{t('terms_of_use')}</a></li>
                                        <li><a href={makeRoute("/privacy", appReducer)}>{t('menu_privacy_policy')}</a></li>
                                        <li><a href={makeRoute("/community-guideline", appReducer)}>{isBeYeuTemplate ? t('community_standards') : t('community_guidelines')}</a></li>
                                    </ul>
                                ) : (
                                    <ul>
                                        <li><a href={aboutUsLink}>{t('menu_about_us')}</a></li>
                                        <li><a href={makeRoute("/contact", appReducer)}>{t('menu_feedback')}</a></li>
                                        <li><a href={makeRoute("/privacy", appReducer)}>{t('menu_privacy_policy')}</a></li>
                                        <li><a href={makeRoute("/sitemap", appReducer)}>{t('menu_sitemap_html')}</a></li>
                                    </ul>
                                )
                            }
                    </div>
                    <div className={cx("clear-fix")}></div>
                </div>
            </div>
        </footer>
    )
}

export default translate()(Footer);
